import actions from './actions'

const initState = {
    tasks: [],
    currentTask: null,
    isLoading: false,
    visibleEditModal: false,
    visibleRemoveModal: false,
    visibleCreateModal: false,
    idRemove: 0,
}

const taskReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.GET_LIST_TASK:
            return {
                ...state,
                ...{
                    isLoading: true,
                },
            }

        case actions.type.GET_LIST_TASK_DONE:
            return {
                ...state,
                ...{
                    isLoading: false,
                    tasks: action.payload.data,
                },
            }
        case actions.type.VISIBLE_EDIT_MODAL:
            return {
                ...state,
                ...{
                    visibleEditModal: action.payload.visible,
                },
            }
        case actions.type.GET_CURRENT_TASK_DONE:
            return {
                ...state,
                ...{
                    currentTask: action.payload.data,
                },
            }
        default:
            return state
    }
}

export default taskReducer
